// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_editor__main_container__J6E0D {
  width: 100%;
  display: flex;
  justify-content: space-between;
  overflow: visible;
  overflow-x: clip;
}

.editor_editor__container__2RsMu {
  position: relative;
  max-width: 1215px;  
  width: 100%;
  margin: 0 0 20px;
  overflow: visible;
  overflow-x: clip;
  text-align: left;

  color: #000;
  background: #fff;

  font-weight: 400;
  line-height: 20px;
}

.editor_editor__inner__KbcXH {
  position: relative;
  max-width: 1215px;
  overflow: auto;
  overflow-x: visible;

  min-height: 160px;

  /* max-height: 300px; */
  padding: 0;

  /* resize: vertical; */

  /* border: 1px solid #B2B5BB; */
  border-radius: 0.25rem;
}

.editor_editor__input__MAiIF {
  position: relative;

  min-height: 150px;
  padding: 15px;

  cursor: text;

  tab-size: 1;

  outline: 0;

  caret-color: #444;
}

@media (max-width: 1800px) {
  .editor_editor__input__MAiIF
  .editor_editor__inner__KbcXH {
    max-width: calc(100% - 300px);
  }
}

@media (max-width: 840px) {
  .editor_editor__input__MAiIF
  .editor_editor__inner__KbcXH {
    max-width: 50%;
  }
}

.editor_editor__placeholder__POYaK {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  padding: 16px;

  pointer-events: none;
}

.editor_editorPreview__container__RJ52a {
  position: relative;
  display: flex;
  /* justify-content: space-between; */
  overflow-x: clip;
  overflow-y: visible;
  text-align: left;
  margin-top: 10px;
  color: #000;
  background: #fff;
  width: 100%; 

  font-weight: 400;
  line-height: 20px;
}


.editor_editorPreview__inner__chwM7 {
  position: relative;
  max-width: 1215px;
  overflow-x: visible;
}



.editor_editorPreview__input__Igr0g {
  position: relative;

  tab-size: 1;

  outline: 0;

  caret-color: #444;
}

@media (max-width: 1800px) {
  .editor_editorPreview__inner__chwM7 {
    max-width: calc(100% - 300px);
  }
}

@media (max-width: 840px) {
  .editor_editorPreview__inner__chwM7 {
    max-width: 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/form/Editor/editor.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;;EAEhB,WAAW;EACX,gBAAgB;;EAEhB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;;EAEnB,iBAAiB;;EAEjB,uBAAuB;EACvB,UAAU;;EAEV,sBAAsB;;EAEtB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;;EAElB,iBAAiB;EACjB,aAAa;;EAEb,YAAY;;EAEZ,WAAW;;EAEX,UAAU;;EAEV,iBAAiB;AACnB;;AAEA;EACE;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;;EAEP,WAAW;EACX,YAAY;;EAEZ,aAAa;;EAEb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,WAAW;;EAEX,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;;;AAIA;EACE,kBAAkB;;EAElB,WAAW;;EAEX,UAAU;;EAEV,iBAAiB;AACnB;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".editor__main_container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  overflow: visible;\n  overflow-x: clip;\n}\n\n.editor__container {\n  position: relative;\n  max-width: 1215px;  \n  width: 100%;\n  margin: 0 0 20px;\n  overflow: visible;\n  overflow-x: clip;\n  text-align: left;\n\n  color: #000;\n  background: #fff;\n\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.editor__inner {\n  position: relative;\n  max-width: 1215px;\n  overflow: auto;\n  overflow-x: visible;\n\n  min-height: 160px;\n\n  /* max-height: 300px; */\n  padding: 0;\n\n  /* resize: vertical; */\n\n  /* border: 1px solid #B2B5BB; */\n  border-radius: 0.25rem;\n}\n\n.editor__input {\n  position: relative;\n\n  min-height: 150px;\n  padding: 15px;\n\n  cursor: text;\n\n  tab-size: 1;\n\n  outline: 0;\n\n  caret-color: #444;\n}\n\n@media (max-width: 1800px) {\n  .editor__input\n  .editor__inner {\n    max-width: calc(100% - 300px);\n  }\n}\n\n@media (max-width: 840px) {\n  .editor__input\n  .editor__inner {\n    max-width: 50%;\n  }\n}\n\n.editor__placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  width: 100%;\n  height: 100%;\n\n  padding: 16px;\n\n  pointer-events: none;\n}\n\n.editorPreview__container {\n  position: relative;\n  display: flex;\n  /* justify-content: space-between; */\n  overflow-x: clip;\n  overflow-y: visible;\n  text-align: left;\n  margin-top: 10px;\n  color: #000;\n  background: #fff;\n  width: 100%; \n\n  font-weight: 400;\n  line-height: 20px;\n}\n\n\n.editorPreview__inner {\n  position: relative;\n  max-width: 1215px;\n  overflow-x: visible;\n}\n\n\n\n.editorPreview__input {\n  position: relative;\n\n  tab-size: 1;\n\n  outline: 0;\n\n  caret-color: #444;\n}\n\n@media (max-width: 1800px) {\n  .editorPreview__inner {\n    max-width: calc(100% - 300px);\n  }\n}\n\n@media (max-width: 840px) {\n  .editorPreview__inner {\n    max-width: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor__main_container": `editor_editor__main_container__J6E0D`,
	"editor__container": `editor_editor__container__2RsMu`,
	"editor__inner": `editor_editor__inner__KbcXH`,
	"editor__input": `editor_editor__input__MAiIF`,
	"editor__placeholder": `editor_editor__placeholder__POYaK`,
	"editorPreview__container": `editor_editorPreview__container__RJ52a`,
	"editorPreview__inner": `editor_editorPreview__inner__chwM7`,
	"editorPreview__input": `editor_editorPreview__input__Igr0g`
};
export default ___CSS_LOADER_EXPORT___;
